export const FLYBITS = {
    IDP_HOST: process.env.REACT_APP_FLYBITS_IDP_HOST,
    FLYBITS_HOST: process.env.REACT_APP_FLYBITS_HOST,
    FLYBITS_PROXY_HOST: process.env.REACT_APP_FLYBITS_PROXY_HOST
}

export const HEADERS = {
    X_API_HOST: 'x-api-host',
}



// WEBPACK FOOTER //
// ./src/constants/index.tsx